var OfferPricingMonthly = /*@__PURE__*/ (function () {
    function OfferPricingMonthly() {
        this.price = 0;
        this.isDiscounted = false;
        this.discountedPrice = 0;
    }
    return OfferPricingMonthly;
}());
export { OfferPricingMonthly };
var OfferPricingOnetime = /*@__PURE__*/ (function () {
    function OfferPricingOnetime() {
        this.price = 0;
        this.isDiscounted = false;
        this.discountedPrice = 0;
    }
    return OfferPricingOnetime;
}());
export { OfferPricingOnetime };
var OfferPricing = /*@__PURE__*/ (function () {
    function OfferPricing() {
    }
    return OfferPricing;
}());
export { OfferPricing };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/schema/offer/offer.pricing.ts
// module id = null
// module chunks = 